<template>

    <v-modal
        :open="open"
        class="c-edit_office_modal">
        <h2 class="c-edit_office_modal__title">Edycja nazwy placówki</h2>
        <form @submit.prevent="ok" data-vv-scope="edit_office-form">
            <form-input
                v-model="office.name"
                label="Nazwa placówki"
                v-validate="'required'"
                data-vv-as="placówka"
                speech-to-text>
            </form-input>
            <form-row align="between">
                <v-btn
                    type="green"
                    role="submit"
                    has-loader
                    :loading="isLoading">
                    Zapisz
                </v-btn>
                <v-btn
                    type="white"
                    @click="cancel">
                    Anuluj
                </v-btn>
            </form-row>
        </form>
    </v-modal>

</template>


<script>

import {mapGetters} from 'vuex'
import VModal from 'Components/VModal'
import {FormRow, FormInput} from 'Components/Form'
import VBtn from 'Components/VBtn'

export default {

    name: 'SettingsOfficeEditModal',

    data() {
        return {
            office: {},
            open: false,
            isLoading: false
        }
    },

    methods: {
        cancel() {
            this.open = false
            this.$emit('cancel', this.office)
        },

        ok() {
            this.$validator.validateAll('edit_office-form').then((isValid) => {
                if (isValid) {
                    this.isLoading = true
                    this.$emit('ok', this.office, this.closeModal)
                }
            })
        },
        closeModal() {
            this.isLoading = false
            this.open = false
        }
    },

    mounted() {
        this.$on('open', (office) => {
            this.open = true
            this.office = JSON.parse(JSON.stringify(office))
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        FormRow,
        FormInput,
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-edit_office_modal {
    &__title {
        margin-bottom: 2rem;
    }
}

</style>
